/* This file was generated by running "node scripts/generateTranslations.js". */
/* Created: 2026-09-10 13:57:07 */

const Keys = {
  headlineflight: 'headlineflight',
  headlinecar: 'headlinecar',
  adult: 'adult',
  child: 'child',
  infant: 'infant'
}; export default Keys;